// extracted by mini-css-extract-plugin
export default {"container":"EmbeddedInsurance_container__QO5Hj","content":"EmbeddedInsurance_content__Bvi-6"};